import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.claimVm.lobs.homeowners.propertyFireDamage.value = $scope.claimVm.lobs.homeowners.propertyFireDamage.value ||
            {
                isHomeHabitable: true,
                isHomeSecure: true
            };
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;